export default __webpack_public_path__ + "static/media/icon-Lyra_circled.8ad89a64.svg";